"use strict";
var nextReactRootIndex = 0;
var ClientReactRootIndex = {
  createReactRootIndex: function() {
    return nextReactRootIndex++;
  }
};
module.exports = ClientReactRootIndex;
